import React from 'react';

export default function IncumbentPricingBlock({ 
  incumbentPricing, 
  setIncumbentPricing,
  proposedPricing,
  achFeeType
}) {
  return (
    <div>
      {/* Tier Thresholds */}
      <div className="mb-6">
        <h3 className="font-semibold mb-3">CC - Tier Thresholds</h3>
        <div className="grid grid-cols-2 gap-4">
          {[1, 2, 3].map(tier => (
            <React.Fragment key={tier}>
              <div>
                <label className="block text-xs text-slate-600 mb-1">
                  Tier {tier} Max Amount <span className="text-blue-600 font-bold">($)</span>
                </label>
                <div className="relative">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-500 font-semibold text-xs">$</span>
                  <input
                    type="number"
                    value={incumbentPricing[`tier${tier}MaxAmount`]}
                    onChange={(e) => setIncumbentPricing({ ...incumbentPricing, [`tier${tier}MaxAmount`]: parseFloat(e.target.value) || 0 })}
                    onFocus={(e) => setTimeout(() => e.target.select(), 0)}
            onClick={(e) => e.target.select()}
                    className="input-field text-sm bg-yellow-50 pl-6"
                    step="0.01"
                    placeholder={tier === 1 ? "50" : tier === 2 ? "100" : "9999"}
                  />
                </div>
              </div>
              <div>
                <label className="block text-xs text-slate-600 mb-1">
                  Tier {tier} Minimum Fee <span className="text-blue-600 font-bold">($)</span>
                </label>
                <div className="relative">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-500 font-semibold text-xs">$</span>
                  <input
                    type="number"
                    value={incumbentPricing[`tier${tier}MinFee`]}
                    onChange={(e) => setIncumbentPricing({ ...incumbentPricing, [`tier${tier}MinFee`]: parseFloat(e.target.value) || 0 })}
                    onFocus={(e) => setTimeout(() => e.target.select(), 0)}
            onClick={(e) => e.target.select()}
                    className="input-field text-sm bg-yellow-50 pl-6"
                    step="0.01"
                    placeholder={tier === 1 ? "1.00" : tier === 2 ? "1.50" : "2.00"}
                  />
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* Payment Type Pricing */}
      <div>
        <h3 className="font-semibold mb-3">Payment Type Pricing</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-100">
                <th className="text-left p-2">Payment Type</th>
                <th className="text-left p-2">Take Rate <span className="text-blue-600 font-bold">(%)</span></th>
                <th className="text-left p-2">Minimum Fee <span className="text-blue-600 font-bold">($)</span></th>
                <th className="text-left p-2">Merchant Fee <span className="text-blue-600 font-bold">(%)</span></th>
              </tr>
            </thead>
            <tbody>
              {['ACH', 'CC', 'AMEX', 'DEBIT'].map(type => (
                <tr key={type} className="border-b">
                  <td className="p-2 font-medium">{type}</td>
                  <td className="p-2">
                    <div className="relative">
                      <input
                        type="number"
                        value={incumbentPricing.paymentRates[type].takeRate}
                        onChange={(e) => setIncumbentPricing({
                          ...incumbentPricing,
                          paymentRates: {
                            ...incumbentPricing.paymentRates,
                            [type]: { ...incumbentPricing.paymentRates[type], takeRate: parseFloat(e.target.value) || 0 }
                          }
                        })}
                        onFocus={(e) => setTimeout(() => e.target.select(), 0)}
            onClick={(e) => e.target.select()}
                        className="input-field text-sm w-24 bg-yellow-50 pr-7"
                        step="0.01"
                        placeholder="3.00"
                      />
                      <span className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-500 font-semibold text-xs">%</span>
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="relative">
                      <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-500 font-semibold text-xs">$</span>
                      <input
                        type="number"
                        value={incumbentPricing.paymentRates[type].minFee}
                        onChange={(e) => setIncumbentPricing({
                          ...incumbentPricing,
                          paymentRates: {
                            ...incumbentPricing.paymentRates,
                            [type]: { ...incumbentPricing.paymentRates[type], minFee: parseFloat(e.target.value) || 0 }
                          }
                        })}
                        onFocus={(e) => setTimeout(() => e.target.select(), 0)}
            onClick={(e) => e.target.select()}
                        className="input-field text-sm w-24 bg-yellow-50 pl-6"
                        step="0.01"
                        placeholder="1.00"
                      />
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="relative flex items-center gap-2">
                      <div className="relative flex-1">
                        {type === 'ACH' && achFeeType === 'flat' ? (
                          <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-500 font-semibold text-xs">$</span>
                        ) : null}
                        <input
                          type="number"
                          value={proposedPricing?.paymentRates?.[type]?.merchantFee || 0}
                          className={`input-field text-sm w-24 bg-green-50 border-green-300 ${type === 'ACH' && achFeeType === 'flat' ? 'pl-6 pr-16' : 'pr-16'}`}
                          readOnly
                          title="Auto-filled from Block 4 Proposed Pricing"
                        />
                        <span className="absolute right-2 top-1/2 -translate-y-1/2 text-green-700 font-semibold text-xs">
                          {type === 'ACH' ? (achFeeType === 'flat' ? 'per trnx' : '%') : '%'}
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
